import { useEffect, useState } from "react";
import { roomClient } from "./shared-room-client";

export interface SharedRoomClientConfig {
  enabled: boolean;
  uiEnabled: boolean;
  writesEnabled: boolean;
  /** Older servers omit it; there every enabled user may start a room. */
  canCreate?: boolean;
  schemaVersion: number;
  maxUploadSizeBytes: number;
  mediaScan?: "off" | "required";
  media?: Record<string, unknown>;
}
export function useSharedRoomsEnabled(): boolean {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    const controller = new AbortController();
    void roomClient
      .read<SharedRoomClientConfig>("/api/rooms/config", controller.signal)
      .then((config) => {
        if (!controller.signal.aborted)
          setEnabled(config.enabled && config.uiEnabled && config.schemaVersion === 1);
      })
      .catch(() => {
        if (!controller.signal.aborted) setEnabled(false);
      });
    return () => controller.abort();
  }, []);
  return enabled;
}
